import React from 'react'
import { useCountdown } from './utilities/countdown'
import { pad } from './helpers/pad'

import * as Styled from './TranspaisCountdown.styled'

const TranspaisCountdown = ({date, type, format, danger}) => {
  const [days, hours, minutes, seconds, remaining] = useCountdown(date)

  const parseFormat = (format) => {
    const dateComponents = format.split(':')
    let showDays = false, showHours = false, showMinutes = false, showSeconds = false

    dateComponents.forEach((dateComponent) => {
      switch (dateComponent) {
        case 'd':
          showDays = true
          break
        case 'h':
          showHours = true
          break
        case 'm':
          showMinutes = true
          break
        case 's':
          showSeconds = true
          break
        default:
          break
      }
    })

    return [showDays, showHours, showMinutes, showSeconds]
  }

  const [showDays, showHours, showMinutes, showSeconds] = parseFormat(format)

  if (danger == null) {
    danger = 5
  }

  return (type === 'simple' &&
    <TranspaisSimpleCounter
      showDays={ showDays }
      days={ days }
      showHours={ showHours }
      hours={ hours }
      showMinutes={ showMinutes }
      minutes={ minutes }
      showSeconds={ showSeconds }
      seconds={ seconds }
      danger={ remaining <= danger }
    />
  )
}

const TranspaisSimpleCounter = ({
                                  showDays,
                                  days,
                                  showHours,
                                  hours,
                                  showMinutes,
                                  minutes,
                                  showSeconds,
                                  seconds,
                                  danger
                                }) => {
  return (
    <Styled.SimpleCountdownWrapper>
      { showDays && (<>
        <TranspaisSimpleDateTimeDisplay value={ pad(days, 2) } isDanger={ danger }/>
        <span>:</span>
      </>) }
      { showHours && (<>
        <TranspaisSimpleDateTimeDisplay value={ pad(hours, 2) } isDanger={ danger }/>
        <span>:</span>
      </>) }
      { showMinutes && (<>
        <TranspaisSimpleDateTimeDisplay value={ pad(minutes, 2) } isDanger={ danger }/>
        <span>:</span>
      </>) }
      { showSeconds && (<TranspaisSimpleDateTimeDisplay value={ pad(seconds, 2) } isDanger={ danger }/>) }
    </Styled.SimpleCountdownWrapper>
  )
}

const TranspaisSimpleDateTimeDisplay = ({value, isDanger}) => {
  return (
    <Styled.SimpleDateTimeDisplay danger={ isDanger }>{ value }</Styled.SimpleDateTimeDisplay>
  )
}

const DateTimeDisplay = ({value, type, isDanger}) => {
  return (
    <div className={ isDanger ? 'countdown danger' : 'countdown' }>
      <p>{ value }</p>
      <span>{ type }</span>
    </div>
  )
}

export default TranspaisCountdown